import React, { useEffect } from 'react';
import styled from 'App/styled';
import statusCodes from 'constants/statusCodes';
import { pushEvent } from '@nykaa/data-layer';
import SearchError from './SearchError';

const GO_BACK_TEXT = 'GO BACK TO HOME PAGE';
const NOT_FOUND_IMAGE =
  '//www.nykaa.com/skin/frontend/nykaa/theme202/images/Page-Not-Found.jpg';

const getStatusText = (statusCode: number) => {
  switch (statusCode) {
    case statusCodes.NOT_FOUND:
      return "Sorry! We couldn't find the page you are looking for.";

    default:
      return 'Sorry, Something went wrong!';
  }
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
  height: 80vh;
  background: #fff;

  .image {
    max-width: 100%;
    height: 250px;
  }

  .status-text {
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    padding: 20px 30px;
    ${({ theme }) => theme.typography.type241};
    color: #fff;
    text-align: center;
    margin: 20px 0;
  }

  .home-link {
    font-weight: bold;
    padding: 12px 20px;
    font-size: 0.9rem;
    border-radius: 4px;
    text-decoration: none;
    background: #fc2779;
    color: #fff;
  }
`;

const ErrorWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.surface};
  max-width: 1200px;
  margin: 0px auto;
`;

interface ErrorProps {
  statusCode: number;
  showPageNotFoundV2: boolean;
  pageNotFoundTitle: string;
  pageNotFoundSubtitle: string;
  redirectText: string;
}
const ERROR_PAGE_LOAD_EVENT = 'errorPageLoad';

function Error({
  statusCode,
  showPageNotFoundV2,
  pageNotFoundTitle,
  pageNotFoundSubtitle,
  redirectText,
}: ErrorProps) {
  const statusText = getStatusText(statusCode);
  useEffect(() => {
    if (statusCode === statusCodes.NOT_FOUND)
      pushEvent(ERROR_PAGE_LOAD_EVENT, {
        statusText,
      });
  }, [statusCode, statusText]);

  return (
    <>
      {showPageNotFoundV2 ? (
        <ErrorWrapper>
          <SearchError
            title={pageNotFoundTitle}
            subTitle={pageNotFoundSubtitle}
            redirectText={redirectText}
          />
        </ErrorWrapper>
      ) : (
        <Container>
          <img
            className="image"
            src={NOT_FOUND_IMAGE}
            alt="not found"
            height={250}
          />
          <div className="status-text">{getStatusText(statusCode)}</div>
          <a
            href="/"
            className="home-link"
          >
            {GO_BACK_TEXT}
          </a>
        </Container>
      )}
    </>
  );
}

export default Error;
